import React from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import WatermarkField from '../../../../../form-fields/super-cut/watermark'

const Watermark = styled(WatermarkField)`
    grid-column: span 1;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoWatermarkField = ({ field }: Props) => {
    return (
        <Watermark
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoWatermarkField
